// utils/formConfig.js
import * as Yup from "yup";

export const SUPPORTED_FORMATS = [
  "image/png", "image/jpeg", "image/jpg", "image/webp", "image/svg+xml",
];

export const ASPECTS = {
  square: 1, portrait: 3 / 4, landscape: 16 / 9, free: null,
};

export const MAX_IMAGE_SIZE = 2 * 1024 * 1024;
export const DRAFT_KEY      = "px_multistep_draft";
export const AVATAR_SIZE    = 256;

// ─────────────────────────────────────────────────────────────────────────────
// MANUAL flow
// ─────────────────────────────────────────────────────────────────────────────
export const STEP_LABELS = [
  "Merchant Details",  // step 1
  "Form Details",      // step 2
  "Upload Logo",  // step 3
  "Create Form",   
  "UDF Mappings"    
];

const role = atob(localStorage.getItem("role"));

export const schemas = [
  // Step 1 — Merchant Details
  Yup.object({
  merchantId: role === "MERCHANT" || role === "VIEWER"
    ? Yup.string() // optional
    : Yup.string().required("Merchant ID is required"),

    username: Yup.string()
      .required("Username is required")
      .min(3, "Username must be at least 3 characters")
      .max(30, "Username cannot exceed 30 characters"),

  password: Yup.string()
  .required("Password is required")
  .matches(
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])(?!.*(\d)\1{2,}).{8,}$/,
    "Password must be at least 8 characters, include uppercase, lowercase, number, special character, and avoid continuous digits"
  )
  .max(20, "Password cannot exceed 20 characters"),
  }),

  // Step 2 — Form Details
  Yup.object({
    title: Yup.string()
      .required("Title is required")
      .max(100, "Title cannot exceed 100 characters"),

    slug: Yup.string()
      .required("Slug is required")
      .matches(/^[a-z0-9-]+$/, "Slug can only contain lowercase letters, numbers, and hyphens")
      .max(50, "Slug cannot exceed 50 characters"),

    description: Yup.string()
      .nullable()
      .max(250, "Description cannot exceed 250 characters"),

merchPhone: Yup.string()
  .required("Phone number is required")
  .matches(
    /^[0-9]{10}$/,
    "Must be exactly 10 digits"
  ),

merchEmail: Yup.string()
  .required("Email is required")
  .email("Must be a valid email address"),

    sendReceiptEmail: Yup.boolean(),
    stakeholderNotification:
  Yup.boolean(),
  stakeholderEmails: Yup.array().when(
  "stakeholderNotification",
  {
    is: true,
    then: (schema) =>
      schema
        .of(
          Yup.string()
            .required(
              "Email is required"
            )
            .email(
              "Invalid email"
            )
        )
        .min(
          1,
          "At least one stakeholder email is required"
        ),
    otherwise: (schema) =>
      schema.notRequired(),
  }
),

  }),

  // Step 3 — Upload Form Logo
  Yup.object({}),

  // Step 4 — Create Form
  Yup.object({}),

   Yup.object({
    udi1: Yup.string().nullable(),
    udi2: Yup.string().nullable(),
    udi3: Yup.string().nullable(),
    udi4: Yup.string().nullable(),
    udi5: Yup.string().nullable(),
    udi6: Yup.string().nullable(),
    udi7: Yup.string().nullable(),
    udi8: Yup.string().nullable(),
    udi9: Yup.string().nullable(),
    udi10: Yup.string().nullable(),
  }),
 
];

// ─────────────────────────────────────────────────────────────────────────────
// EXCEL flow
// ─────────────────────────────────────────────────────────────────────────────
export const EXCEL_STEP_LABELS = [
  "Merchant Details",  // step 1
  "Form Details",      // step 2
  "Upload Logo",  // step 3
  "Upload Excel Data", // step 4
  "Create Form",  
  "UDF Mappings"     
];

export const excelSchemas = [
  // Step 1 — Merchant Details
  Yup.object({
    merchantId: Yup.string()
      .required("Merchant ID is required")
      .min(3, "Merchant ID must be at least 3 characters")
      .max(50, "Merchant ID cannot exceed 50 characters"),

    username: Yup.string()
      .required("Username is required")
      .min(3, "Username must be at least 3 characters")
      .max(30, "Username cannot exceed 30 characters"),

    password: Yup.string()
      .required("Password is required")
      .matches(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])(?!.*(\d)\1{2,}).{8,}$/,
        "Password must be at least 8 characters, include uppercase, lowercase, number, special character, and avoid continuous digits"
      )
      .max(64, "Password cannot exceed 64 characters"),
  }),

  // Step 2 — Form Details
  Yup.object({
    title: Yup.string()
      .required("Title is required")
      .min(3, "Title must be at least 3 characters")
      .max(100, "Title cannot exceed 100 characters"),

    slug: Yup.string()
      .required("Slug is required")
      .matches(/^[a-z0-9-]+$/, "Slug can only contain lowercase letters, numbers, and hyphens")
      .min(3, "Slug must be at least 3 characters")
      .max(50, "Slug cannot exceed 50 characters"),

    description: Yup.string()
      .nullable()
      .max(250, "Description cannot exceed 250 characters"),

  merchPhone: Yup.string()
  .required("Phone number is required")
  .matches(
    /^[0-9]{10}$/,
    "Must be exactly 10 digits"
  ),


merchEmail: Yup.string()
  .required("Email is required")
  .email("Must be a valid email address"),
    sendReceiptEmail: Yup.boolean(),
  }),

  // Step 3 — Upload Form Logo
  Yup.object({}),

  // Step 4 — Excel upload
  Yup.object({
    excelColumns: Yup.array()
      .min(1, "Please upload an Excel file and confirm the fields before continuing"),
    excelSearchKey: Yup.string()
      .required("Please select a search key before continuing"),
  }),

  // Step 5 — Create Form
  Yup.object({}),

   Yup.object({
    udi1: Yup.string().nullable(),
    udi2: Yup.string().nullable(),
    udi3: Yup.string().nullable(),
    udi4: Yup.string().nullable(),
    udi5: Yup.string().nullable(),
    udi6: Yup.string().nullable(),
    udi7: Yup.string().nullable(),
    udi8: Yup.string().nullable(),
    udi9: Yup.string().nullable(),
    udi10: Yup.string().nullable(),
  }),
 
];

// ─────────────────────────────────────────────────────────────────────────────
// Shared default values
// ─────────────────────────────────────────────────────────────────────────────
export const defaultValues = {
  merchantId: "",
  username:   "",
  password:   "",
  title:            "",
  slug:             "",
  description:      "",
  merchPhone:       "",
  merchEmail:       "",
  stakeholderNotification: false,
  stakeholderEmails: [""],
  merchantNotification: false,
  sendReceiptEmail: false,
  customReceipt:    false,
  avatar: null,
  secondaryLogo: null,
  mode : "",
  excelFile:      null,
  excelColumns:   [],   
  excelSearchKey: "",
  formName: "",
  confirm:  false,
  udi1: "",
  udi2: "",
  udi3: "",
  udi4: "",
  udi5: "",
  udi6: "",
  udi7: "",
  udi8: "",
  udi9: "",
  udi10: "",
 
};

export const loadDraft = () => {
  try {
    const d = localStorage.getItem(DRAFT_KEY);
    return d ? JSON.parse(d) : null;
  } catch (_) { return null; }
};

export const saveDraft = (values) => {
  const { avatar, excelFile, ...rest } = values;
  // localStorage.setItem(DRAFT_KEY, JSON.stringify(rest));
};
